import { Menu, MenuButton } from '@headlessui/react';
import UntitledIcon from '@payaca/untitled-icons';
import { FunctionComponent } from 'react';
import {
  TAvatarBorderColourVariant,
  TAvatarSizeVariant,
  avatarVariants,
} from '../Avatar/avatarVariants';
import DropdownMenuItems, {
  TDropdownItem,
  TDropdownSection,
} from '../Dropdown/DropdownMenuItems';

type DropdownMenuButtonProps = {
  menuItems?: TDropdownItem[] | TDropdownSection[];
  hasSearch?: boolean;
  sizeVariant?: TAvatarSizeVariant;
  borderColourVariant?: TAvatarBorderColourVariant;
  className?: string;
};

const AvatarDropdownMenuButton: FunctionComponent<DropdownMenuButtonProps> = ({
  menuItems = [],
  sizeVariant,
  borderColourVariant,
  hasSearch = false,
  className,
}) => {
  return (
    <Menu as="div" className="relative">
      <MenuButton
        as={'button'}
        className={avatarVariants({
          className:
            'relative p-0 rounded-full flex items-center cursor-pointer bg-white focus:outline-none focus:ring-2 focus:ring-offset-2',
          size: sizeVariant,
          border: borderColourVariant,
          shape: 'circle',
        })}
      >
        <UntitledIcon
          name={'dots-horizontal.3'}
          // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Positioned relative to the avatar
          className={`absolute bottom-[3%] pointer-events-none left-1/2 -translate-x-1/2 ${avatarVariants(
            {
              icon: sizeVariant,
              size: null,
              border: null,
              shape: null,
            }
          )}`}
        />
      </MenuButton>

      <DropdownMenuItems
        items={menuItems}
        hasSearch={hasSearch}
        className={className}
        autoClose={false}
      />
    </Menu>
  );
};

export default AvatarDropdownMenuButton;
